var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.7475 1.33333V3.99999M5.41418 1.33333V3.99999",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.74748 2.66667H7.41414C4.89998 2.66667 3.64291 2.66667 2.86186 3.44772C2.08081 4.22877 2.08081 5.48585 2.08081 8.00001V9.33334C2.08081 11.8475 2.08081 13.1046 2.86186 13.8856C3.64291 14.6667 4.89998 14.6667 7.41414 14.6667H8.74748C11.2616 14.6667 12.5187 14.6667 13.2997 13.8856C14.0808 13.1046 14.0808 11.8475 14.0808 9.33334V8.00001C14.0808 5.48585 14.0808 4.22877 13.2997 3.44772C12.5187 2.66667 11.2616 2.66667 8.74748 2.66667Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.08081 6.66667H14.0808",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.07785 9.33333H8.08385M8.07785 12H8.08385M10.7415 9.33333H10.7475M5.41418 9.33333H5.42016M5.41418 12H5.42016",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDate);
export default __webpack_public_path__ + "static/media/date.ceeccb7520761b3f3abfca0da8a36b53.svg";
export { ForwardRef as ReactComponent };